import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import App from './App'
import './index.css'
import i18n from './lib/i18n'
import { PostHogProvider } from 'posthog-js/react'

// Update html lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Set initial language
document.documentElement.lang = i18n.language;

const hashParams = new URLSearchParams(window.location.hash.substring(1))
const distinct_id = hashParams.get('distinct_id')
const session_id = hashParams.get('session_id')
const options = {
  api_host: '/sylva-relay/',
  ui_host: 'https://eu.posthog.com',
  disable_surveys: true,
  bootstrap: {
    sessionID: session_id || undefined,
    distinctID: distinct_id || undefined
  },
  person_profiles: "always" as const,
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PostHogProvider apiKey="phc_AN7TpDZYPNywcsdX9NoKiTuku0tig6HTtdrPdUYTArG" options={options}>
          <App />
        </PostHogProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
